<template><div><h1>VUX 2.9.3 released</h1>
<h2><a href="/en/components/picker.html">Picker</a></h2>
<ul><li>[fix] fix Uncaught TypeError: Cannot assign to read only property exports of object #3386</li>
</ul>
<h2><a href="/en/components/selector.html">Selector</a></h2>
<ul><li>[fix] fix the chinese bracket show error when direction=rtl #2864</li>
</ul>
<h2><a href="/en/components/v-chart.html">VChart</a></h2>
<ul><li>[enhance] v-point can set size and shape, v-line can set shape</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX 2.9.3 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// 2.9.3-62.vue?73d64f92